import type { MediaItem } from "@/types/media";

export const mediaList: MediaItem[] = [
  {
    id: "deep-echo",
    title: "深海回声",
    type: "movie",
    year: 2024,
    region: "华语",
    genres: ["科幻", "悬疑"],
    director: "沈屿舟",
    cast: ["陆见川", "白清岚", "周牧野", "顾望舒"],
    rating: 8.7,
    views: 1286,
    duration: "2小时18分",
    synopsis:
      "一座位于马里亚纳海沟边缘的深海研究站，在收听到一段无法解释的低频回响后与地面彻底失联。海洋学家沈知远受命下潜调查，却在漆黑的海底发现了一段比深渊更古老的秘密。随着氧气不断减少，他必须在真相与生还之间做出抉择。",
    tagline: "深渊之下，回响不息",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20poster%20about%20an%20underwater%20research%20station%2C%20deep%20navy%20and%20charcoal%20tones%20with%20an%20eerie%20teal%20glow%2C%20a%20solitary%20diver%20silhouette%20facing%20a%20colossal%20shadow%20in%20the%20deep%20ocean%2C%20dramatic%20rim%20lighting%2C%20minimalist%20composition%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=deep-echo-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20scene%20of%20a%20lonely%20deep%20sea%20research%20station%20suspended%20in%20pitch%20dark%20water%2C%20deep%20blue%20and%20charcoal%20palette%20with%20faint%20teal%20bioluminescent%20glow%2C%20vast%20empty%20abyss%2C%20moody%20atmosphere%2C%20artistic%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=deep-echo-backdrop&orientation=landscape",
    featured: true,
  },
  {
    id: "neon-chase",
    title: "霓虹追缉",
    type: "movie",
    year: 2023,
    region: "华语",
    genres: ["动作", "犯罪"],
    director: "夏一鸣",
    cast: ["江洛", "许澈", "冯晚舟"],
    rating: 8.1,
    views: 1542,
    duration: "2小时05分",
    synopsis:
      "雨夜的城市被霓虹切割成碎片，退役刑警江洛为了追查一桩悬而未决的连环案，重新踏入他早已离开的灰色地带。线索指向一个代号“萤火”的地下网络，而每一条被点亮的霓虹，都在指引他走向不愿面对的真相。",
    tagline: "光越亮，影越深",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20action%20movie%20poster%20of%20a%20lone%20detective%20silhouette%20in%20a%20rainy%20neon%20city%20alley%2C%20charcoal%20and%20deep%20blue%20base%20with%20vivid%20amber%20and%20orange%20neon%20reflections%2C%20wet%20street%20glow%2C%20dramatic%20contrast%20lighting%2C%20minimalist%20composition%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=neon-chase-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20rainy%20city%20street%20at%20night%20with%20glowing%20amber%20neon%20signs%20reflecting%20on%20wet%20asphalt%2C%20charcoal%20and%20deep%20blue%20tones%20with%20orange%20accents%2C%20a%20distant%20running%20figure%2C%20moody%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=neon-chase-backdrop&orientation=landscape",
  },
  {
    id: "summer-post",
    title: "夏日邮局",
    type: "movie",
    year: 2024,
    region: "华语",
    genres: ["爱情", "喜剧", "剧情"],
    director: "林知夏",
    cast: ["温言", "何知南", "苏木"],
    rating: 8.4,
    views: 978,
    duration: "1小时52分",
    synopsis:
      "海边小镇的老邮局即将关闭，最后一任邮差温言决定替那些寄不出的信找到主人。一个总在盛夏出现的游客，一段被海风吹散的旧日约定，让这个夏天成为她一生中最漫长的告别与重逢。",
    tagline: "有些信，要等一个夏天",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20romance%20movie%20poster%20set%20at%20a%20seaside%20post%20office%20in%20summer%2C%20deep%20blue%20dusk%20sky%20with%20soft%20amber%20sunlight%2C%20a%20young%20woman%20holding%20a%20bundle%20of%20letters%20by%20the%20window%2C%20gentle%20nostalgic%20mood%2C%20minimalist%20composition%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=summer-post-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20seaside%20town%20at%20golden%20dusk%20with%20a%20small%20old%20post%20office%2C%20deep%20blue%20evening%20sky%20blending%20into%20warm%20amber%20horizon%2C%20gentle%20nostalgic%20atmosphere%2C%20artistic%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=summer-post-backdrop&orientation=landscape",
  },
  {
    id: "mountain-walker",
    title: "山海行者",
    type: "movie",
    year: 2022,
    region: "华语",
    genres: ["奇幻", "冒险"],
    director: "顾长风",
    cast: ["敖野", "秦昭", "白灵儿", "韩冽"],
    rating: 7.9,
    views: 1104,
    duration: "2小时26分",
    synopsis:
      "古籍记载的山海之间，藏着一座会移动的城。少年敖野为寻找失踪的兄长，踏上穿越群山的旅途。他遇见了会说话的异兽、被遗忘的古老部族，也逐渐明白：真正需要被翻越的，从来不是山，而是人心。",
    tagline: "翻过山，越过海",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20fantasy%20adventure%20movie%20poster%20of%20a%20lone%20traveler%20standing%20on%20a%20cliff%20before%20vast%20floating%20mountains%2C%20deep%20blue%20and%20charcoal%20sky%20with%20warm%20amber%20glow%20on%20the%20horizon%2C%20mythical%20atmosphere%2C%20dramatic%20scale%2C%20minimalist%20composition%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=mountain-walker-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20epic%20cinematic%20landscape%20of%20towering%20misty%20mountains%20with%20a%20tiny%20wanderer%20on%20a%20ridge%2C%20deep%20blue%20and%20charcoal%20tones%20with%20strong%20warm%20amber%20light%20breaking%20through%20clouds%2C%20mythical%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=mountain-walker-backdrop&orientation=landscape",
  },
  {
    id: "midnight-train",
    title: "午夜列车",
    type: "movie",
    year: 2023,
    region: "欧美",
    genres: ["悬疑", "惊悚"],
    director: "Elias Grant",
    cast: ["Nora Hale", "Julian Reyes", "Mara Lin"],
    rating: 8.0,
    views: 869,
    duration: "1小时58分",
    synopsis:
      "一列驶向终点的夜行列车，载着十二名互不相识的乘客。当第一站台的灯熄灭后，有人发现：车厢里多出了一位不在名单上的旅客。随着列车不断驶入更深的夜色，每个人都必须面对自己为何登上这趟车。",
    tagline: "下一站，无人下车",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20thriller%20movie%20poster%20of%20an%20old%20night%20express%20train%20rushing%20through%20black%20darkness%2C%20charcoal%20and%20deep%20blue%20tones%20with%20a%20cold%20amber%20headlight%20beam%2C%20lonely%20platform%20in%20the%20distance%2C%20tense%20mysterious%20mood%2C%20minimalist%20composition%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=midnight-train-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20empty%20train%20platform%20at%20night%20with%20a%20lone%20glowing%20train%20approaching%20through%20deep%20blue%20fog%2C%20charcoal%20tones%20with%20faint%20amber%20lamps%2C%20eerie%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=midnight-train-backdrop&orientation=landscape",
  },
  {
    id: "star-return",
    title: "星际归途",
    type: "movie",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "冒险"],
    director: "Selene Novak",
    cast: ["Adrian Cole", "Iris Tanaka", "Leo Marsh"],
    rating: 8.6,
    views: 1713,
    duration: "2小时32分",
    synopsis:
      "当最后一批远航舰队开始返程，导航官艾德里安却发现，地球在星图上消失了。面对燃料耗尽与船员分裂的危机，他必须在浩瀚星海中，找回那个被称为“家”的坐标。",
    tagline: "跨越星海，只为回家",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20gazing%20at%20a%20distant%20blue%20planet%2C%20deep%20navy%20space%20with%20warm%20amber%20nebula%20glow%2C%20quiet%20lonely%20awe%2C%20dramatic%20scale%2C%20minimalist%20composition%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=star-return-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20epic%20cinematic%20space%20scene%20of%20a%20small%20returning%20fleet%20silhouetted%20against%20a%20vast%20deep%20blue%20void%20with%20a%20warm%20amber%20nebula%2C%20silent%20awe%20mood%2C%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=star-return-backdrop&orientation=landscape",
    featured: true,
  },
  {
    id: "long-night",
    title: "长夜将明",
    type: "tv",
    year: 2024,
    region: "国产",
    genres: ["悬疑", "剧情"],
    director: "程亦舟",
    cast: ["顾明澜", "沈泊舟", "苏晚晴", "赵屹"],
    rating: 9.0,
    views: 2360,
    synopsis:
      "十二年前的一桩旧案，让小镇刑警顾明澜始终无法安睡。当相似的案件再次发生，他不得不重新审视当年被草草结案的真相。长长的黑夜里，每个人都在等待天亮的那个瞬间。",
    tagline: "黑夜再长，终有天明",
    episodes: [
      { id: 1, title: "第1集 · 旧案重提", synopsis: "一具被河水冲上岸的旧物，让尘封十二年的案件重新浮出水面。" },
      { id: 2, title: "第2集 · 沉默的证人", synopsis: "唯一在场的目击者，选择了长达十二年的沉默。" },
      { id: 3, title: "第3集 · 雨夜追踪", synopsis: "顾明澜在雨夜重访案发地，发现了一处被忽略的细节。" },
      { id: 4, title: "第4集 · 断裂的线索", synopsis: "看似无关的两起案件，被一根看不见的线悄悄系在一起。" },
      { id: 5, title: "第5集 · 被遗忘的人", synopsis: "档案室里一份缺失的名单，指向一个从未被调查的名字。" },
      { id: 6, title: "第6集 · 长夜将明", synopsis: "当真相终于揭开，顾明澜必须决定，是宽恕还是追究。" },
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20crime%20drama%20series%20poster%20of%20a%20weary%20detective%20under%20flickering%20streetlights%20in%20a%20small%20town%20at%20night%2C%20charcoal%20and%20deep%20blue%20tones%20with%20a%20cold%20amber%20glow%2C%20rain%20and%20mist%2C%20tense%20melancholy%20mood%2C%20minimalist%20composition%2C%20professional%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=long-night-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20quiet%20small%20town%20street%20at%20night%20under%20flickering%20lamps%20with%20thin%20rain%2C%20charcoal%20and%20deep%20blue%20palette%20with%20warm%20amber%20pool%20of%20light%2C%20melancholy%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=long-night-backdrop&orientation=landscape",
    featured: true,
  },
  {
    id: "city-life",
    title: "都市浮生录",
    type: "tv",
    year: 2023,
    region: "国产",
    genres: ["都市", "爱情", "喜剧"],
    director: "唐悠然",
    cast: ["林漾", "陆之遥", "何嘉树", "方念"],
    rating: 8.3,
    views: 1980,
    synopsis:
      "五个住在同一栋老楼里的年轻人，各自背着不同的疲惫与梦想。他们在电梯里擦肩，在深夜的阳台上倾诉，也在一次次意外里，慢慢学会了如何与这座城市和解。",
    tagline: "人间烟火，各有浮生",
    episodes: [
      { id: 1, title: "第1集 · 搬来的那天", synopsis: "林漾拖着一只坏掉的行李箱，搬进了这栋没有电梯的老楼。" },
      { id: 2, title: "第2集 · 电梯坏了", synopsis: "一次电梯故障，让五个陌生人第一次真正坐下来聊天。" },
      { id: 3, title: "第3集 · 深夜厨房", synopsis: "加班回来的那晚，楼道里飘起了谁家的宵夜香气。" },
      { id: 4, title: "第4集 · 未寄出的简历", synopsis: "陆之遥把一封辞职信删了又写，写了又删。" },
      { id: 5, title: "第5集 · 天台电影院", synopsis: "他们在天台上支起投影仪，看了一场只属于自己的电影。" },
      { id: 6, title: "第6集 · 各自的浮生", synopsis: "楼要拆了，每个人都有了自己的去向，也都留下了自己的故事。" },
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20urban%20life%20drama%20series%20poster%20of%20five%20young%20people%20on%20an%20old%20apartment%20balcony%20at%20dusk%2C%20deep%20blue%20evening%20sky%20with%20warm%20amber%20window%20lights%2C%20cozy%20melancholy%20mood%2C%20minimalist%20composition%2C%20professional%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=city-life-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20city%20rooftop%20view%20at%20dusk%20with%20warm%20lit%20apartment%20windows%2C%20deep%20blue%20sky%20with%20amber%20horizon%20glow%2C%20cozy%20urban%20atmosphere%2C%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=city-life-backdrop&orientation=landscape",
  },
  {
    id: "south-sea",
    title: "风起南洋",
    type: "tv",
    year: 2022,
    region: "国产",
    genres: ["年代", "历史", "剧情"],
    director: "郑则远",
    cast: ["陈砚秋", "许南洋", "黄婉仪"],
    rating: 8.8,
    views: 1420,
    synopsis:
      "上世纪三十年代的南洋，一场风暴席卷了整片港口。出身贫寒的陈砚秋从码头苦力做起，在动荡的年代里辗转腾挪，见证了一个家族、一座城与一个时代的兴衰。",
    tagline: "浪起南洋，潮涌人间",
    episodes: [
      { id: 1, title: "第1集 · 码头来客", synopsis: "初到南洋的陈砚秋，在码头遇见了改变他一生的贵人。" },
      { id: 2, title: "第2集 · 风起", synopsis: "一场贸易风波，让港口的秩序开始悄然改变。" },
      { id: 3, title: "第3集 · 商号易主", synopsis: "老商号的牌匾被摘下，新势力登上了台面。" },
      { id: 4, title: "第4集 · 隔海的家书", synopsis: "一封迟到的家书，让远渡重洋的人红了眼眶。" },
      { id: 5, title: "第5集 · 港口之夜", synopsis: "潮水涨起的那一夜，许多人的命运被彻底改写。" },
      { id: 6, title: "第6集 · 潮落", synopsis: "时代翻过一页，港口依旧迎来送往。" },
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Period%20cinematic%20historical%20drama%20poster%20of%20a%20young%20laborer%20standing%20on%20a%20busy%20colonial%20harbor%20pier%2C%20deep%20blue%20and%20charcoal%20tones%20with%20warm%20amber%20lantern%20and%20sunset%20glow%2C%20drifting%20ships%20and%20mist%2C%20epic%20nostalgic%20mood%2C%20minimalist%20composition%2C%20professional%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=south-sea-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20colonial%20south%20sea%20harbor%20at%20sunset%20with%20tall%20ships%20and%20glowing%20lanterns%2C%20deep%20blue%20and%20charcoal%20tones%20with%20rich%20amber%20light%2C%20epic%20nostalgic%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=south-sea-backdrop&orientation=landscape",
  },
  {
    id: "hidden-secret",
    title: "暗格里的秘密",
    type: "tv",
    year: 2024,
    region: "国产",
    genres: ["青春", "悬疑"],
    director: "韩映雪",
    cast: ["周予安", "白栀", "沈砚", "林小满"],
    rating: 8.2,
    views: 1755,
    synopsis:
      "高三那年，白栀在旧教室的暗格里发现了一本没有署名的日记。日记里记录的，是这所学校十年前一桩无人提起的往事。随着她一点点接近真相，身边的人也开始变得陌生起来。",
    tagline: "有些秘密，藏在最亮的地方",
    episodes: [
      { id: 1, title: "第1集 · 暗格", synopsis: "搬进旧教室的第一天，白栀在课桌下发现了一个隐秘的暗格。" },
      { id: 2, title: "第2集 · 无名的日记", synopsis: "泛黄的纸页上，写着一个从未被提起的名字。" },
      { id: 3, title: "第3集 · 十年前的合影", synopsis: "一张旧合影里，少了一个人，多了一道划痕。" },
      { id: 4, title: "第4集 · 谁是转学生", synopsis: "转学生的到来，让沉默的班级泛起了涟漪。" },
      { id: 5, title: "第5集 · 天台上的答案", synopsis: "在曾经的事发地，白栀终于拼上了最后一块拼图。" },
      { id: 6, title: "第6集 · 光里的秘密", synopsis: "真相揭开的那一刻，青春也迎来了它迟到的告别。" },
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20youth%20suspense%20drama%20series%20poster%20of%20a%20high%20school%20girl%20holding%20an%20old%20faded%20diary%20in%20a%20quiet%20empty%20classroom%2C%20deep%20blue%20and%20charcoal%20tones%20with%20soft%20amber%20window%20light%2C%20mysterious%20wistful%20mood%2C%20minimalist%20composition%2C%20professional%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=hidden-secret-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20empty%20high%20school%20classroom%20at%20dusk%20with%20long%20shadows%20and%20a%20single%20open%20window%2C%20deep%20blue%20and%20charcoal%20palette%20with%20warm%20amber%20light%2C%20quiet%20mysterious%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=hidden-secret-backdrop&orientation=landscape",
  },
  {
    id: "west-border",
    title: "西部边境",
    type: "tv",
    year: 2023,
    region: "欧美",
    genres: ["西部", "剧情"],
    director: "Calder Boone",
    cast: ["Rhett Dawson", "Mabel Cruz", "Otis Vance"],
    rating: 8.5,
    views: 1310,
    synopsis:
      "在一片被烈日与风沙统治的边境小镇，一个沉默的陌生人骑马到来。他不为淘金，也不为复仇，只在镇外支起一块木牌，上面写着一行字：寻找一条回家的路。",
    tagline: "风沙尽头，是人心的边境",
    episodes: [
      { id: 1, title: "第1集 · 陌生人", synopsis: "一个骑马的陌生人，在黄昏时分走进了边境小镇。" },
      { id: 2, title: "第2集 · 一块木牌", synopsis: "镇外竖起的那块木牌，让所有人都停下了脚步。" },
      { id: 3, title: "第3集 · 水源之争", synopsis: "旱季来临，一口水井成了整个小镇的命脉。" },
      { id: 4, title: "第4集 · 旧日恩怨", synopsis: "一个熟悉的名字，把尘封的往事重新带回镇上。" },
      { id: 5, title: "第5集 · 对峙", synopsis: "两方人马在镇口对峙，风沙掩盖了所有人的表情。" },
      { id: 6, title: "第6集 · 归途", synopsis: "当木牌被取下，陌生人终于说出了他真正的来意。" },
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20western%20drama%20series%20poster%20of%20a%20lone%20horseman%20silhouetted%20against%20a%20dusty%20desert%20horizon%20at%20dusk%2C%20deep%20blue%20and%20charcoal%20tones%20with%20strong%20warm%20amber%20sunlight%2C%20wind%20and%20dust%2C%20rugged%20lonely%20mood%2C%20minimalist%20composition%2C%20professional%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=west-border-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20vast%20desert%20borderland%20at%20golden%20dusk%20with%20a%20tiny%20rider%20and%20a%20lonely%20wooden%20signpost%2C%20deep%20blue%20and%20charcoal%20tones%20with%20warm%20amber%20light%2C%20rugged%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=west-border-backdrop&orientation=landscape",
    featured: true,
  },
  {
    id: "tokyo-story",
    title: "东京物语新编",
    type: "tv",
    year: 2024,
    region: "日韩",
    genres: ["剧情", "家庭"],
    director: "中村夏野",
    cast: ["佐藤凉子", "小林悠介", "高桥真帆"],
    rating: 8.9,
    views: 1160,
    synopsis:
      "年迈的父母第一次来到大都市看望儿女，却发现孩子们各有各的忙碌与疏离。一次短暂的相聚，一场平静的告别，让每个人重新懂得了“家人”这两个字的分量。",
    tagline: "相聚很短，思念很长",
    episodes: [
      { id: 1, title: "第1集 · 初次到访", synopsis: "父母第一次坐上开往大都市的列车，带着大包小包的特产。" },
      { id: 2, title: "第2集 · 各自的忙碌", synopsis: "孩子们嘴上说着欢迎，日程表里却排得满满当当。" },
      { id: 3, title: "第3集 · 一顿家常饭", synopsis: "一家人难得围坐在餐桌前，却谁也不知道该说些什么。" },
      { id: 4, title: "第4集 · 公园的长椅", synopsis: "父母在陌生的城市里散步，在长椅上聊起了年轻时的事。" },
      { id: 5, title: "第5集 · 站台", synopsis: "告别的站台上，母亲把一句叮嘱咽了回去。" },
      { id: 6, title: "第6集 · 一封家书", synopsis: "许久之后，一封手写的信寄到了儿女手中。" },
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20cinematic%20family%20drama%20series%20poster%20of%20an%20elderly%20couple%20sitting%20quietly%20in%20a%20small%20city%20park%2C%20deep%20blue%20and%20charcoal%20tones%20with%20soft%20warm%20amber%20afternoon%20light%2C%20tender%20melancholy%20mood%2C%20minimalist%20composition%2C%20professional%20key%20art%2C%20high%20detail%2C%20clean%20simple%20background&width=500&height=750&seq=tokyo-story-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20quiet%20city%20park%20path%20at%20late%20afternoon%20with%20two%20distant%20elderly%20figures%2C%20deep%20blue%20and%20charcoal%20tones%20with%20soft%20warm%20amber%20light%20through%20trees%2C%20tender%20stylized%20key%20art%2C%20high%20detail%2C%20simple%20uncluttered%20background&width=1600&height=900&seq=tokyo-story-backdrop&orientation=landscape",
  },
];